import React, {Component} from "react";
import Navbar from "../navbar/navbar.js";
import "../login/login.css";

class Signup extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        return (
            <div>
                <Navbar/>
                <div className="login-form">
                    <h1 style={{fontSize: "4em"}}>Contact Us</h1>
                    <form action="https://formspree.io/xvopjylk" method="post" id="contactForm">
                        <div className="form-group ">
                            <input type="text" name="name" className="form-control" placeholder="Name"/>
                        </div>
                        <div className="form-group ">
                            <input type="email" name="email" className="form-control" placeholder="Email"/>
                        </div>
                        <div className="form-group ">
                            <input type="text" name="Company" className="form-control" placeholder="Company"/>
                        </div>
                        <div className="form-group ">
                            <input type="text" name="_subject" className="form-control" placeholder="Subject"/>
                        </div>
                        <div className="form-group ">
                            <textarea type="text" name="message" className="form-control" placeholder="Message"/>
                        </div>
                        <a href="mailto:support@espireads.com" target="_top">
                            Email us support@espireads.com
                        </a>
                        <button form="contactForm" type="submit" className="log-btn">
                            Send
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/components/contact/contact.js